const ActionTypes = {
  getAllVideos: 'GET_ALL_VIDEOS',
  addVideo: 'ADD_NEW_VIDEO'
};

export {
  ActionTypes
};



// WEBPACK FOOTER //
// ./src/constants/constants.js